import { render, staticRenderFns } from "./ForbidenAccess.vue?vue&type=template&id=7205bd19&scoped=true&"
var script = {}
import style0 from "./ForbidenAccess.vue?vue&type=style&index=0&id=7205bd19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7205bd19",
  null
  
)

export default component.exports